import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import {
    Grid,
} from '@mui/material';
import { Button, Input, Select } from 'Components';
import InputDate from 'Components/InputDate';

import { Alert } from '@mui/material';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import moment from 'moment';
import { NotificationManager } from 'Components/Notifications';

import {
    openTimeCardCreateEdit,
    createTimeCard,
    updateTimeCard,
    clearRedux
} from 'Redux/actions';

const TimeCardMesssageEdit = (props) => {
    const { timeZone } = useSelector(state => state.securityRedux.user);
    const { messages } = useIntl();
    const { callBack } = props;
    const dispatch = useDispatch();
    const [TimeCardMData, setTimeCardMData] = useState({});
    const [error, setError] = useState('');
    //Selectors
    const {
        openCreateEditTimeCard,
        response,
        TimeCard,
        loadingCreateEdit
    } = useSelector(state => state.timeCardsRedux);

    const optionsAction = [{
        id: 'I',
        name: messages['FSM_SETTINGS_TIME_CARD_clockIn']
    }, {
        id: 'O',
        name: messages['FSM_SETTINGS_TIME_CARD_clockOut']
    },
    {
        id: 'BO',
        name: messages['FSM_SETTINGS_TIME_CARD_meakbegin']
    },
    {
        id: 'BI',
        name: messages['FSM_SETTINGS_TIME_CARD_meakEnd']
    }];
    useEffect(() => {
        if (response?.error === false) {
            let messageNotification = (TimeCard?.action) ? messages['FSM_SETTINGS_TIME_CARD_update_success'] : messages['FSM_SETTINGS_TIME_CARD_create_success'];
            NotificationManager.success(
                messageNotification,
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );
            handleClose();
        }
    }, [response]);

    const handleClose = useCallback(() => {
        setTimeCardMData({});
        setError('');
        dispatch(clearRedux("FSM_SETTINGS_TIME_CARD", {
            openCreateEditTimeCard: false,
            loadingCreateEdit: false,
            response: {},
            TimeCard: []
        }));

        callBack();
        dispatch(openTimeCardCreateEdit(false))
    });

    useEffect(() => {
        if (TimeCard?.action) {
            const dateTime = new Date(TimeCard?.date);
            setTimeCardMData({
                actionFsm: optionsAction.filter(actions => actions.id == TimeCard?.action)[0],
                dateTime
            });
        } else {
            setTimeCardMData({
                actionFsm: optionsAction[0],
                dateTime: moment()._d,
            });
        }
    }, [TimeCard]);

    const onSubmit = useCallback(() => {
        let date = moment(TimeCardMData?.dateTime).format("YYYY-MM-DD HH:mm:ss")
        let m = moment.tz(date, timeZone);
        date = m.tz("UTC").format('YYYY-MM-DD HH:mm');
        if (TimeCard?.action) {
            dispatch(updateTimeCard({
                id: TimeCard?.id,
                driverId: TimeCard?.fsmDrivers?.driverId,
                action: TimeCardMData?.actionFsm?.id,
                date
            }))
        } else {
            dispatch(createTimeCard({
                driverId: TimeCard?.fsmDrivers?.driverId,
                action: TimeCardMData?.actionFsm?.id,
                date
            }))
        }

    });



    let title = (TimeCard?.action) ? messages['FSM_SETTINGS_TIME_CARD_edit'] : messages['FSM_SETTINGS_TIME_CARD_title'];
    return (
        <Modal
            title={title}
            open={openCreateEditTimeCard}
            loading={loadingCreateEdit}
            size={`small`}
            handleClose={() => handleClose()}
            position="right"
        >
            <ModalBody style={{ overflow: 'hidden', padding: 10, height: 'calc(100vh - 190px)' }}>
                <div >
                    {
                        error &&
                        <Alert severity="error">{error}</Alert>
                    }
                    <Grid
                        container
                        justifyContent={'center'}
                        direction={'column'}
                        className="paddingBody timeCardCreateEditContainer"
                        spacing={2}

                    >
                        <Grid item xs={12} >

                            <Select
                                id="actionFsm"
                                label={messages['FSM_SETTINGS_TIME_CARD_action']}
                                value={TimeCardMData.actionFsm}
                                onChange={(value) => setTimeCardMData({ ...TimeCardMData, actionFsm: value })}
                                options={optionsAction}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </Grid>
                        <Grid item xs={12} >

                            <InputDate
                                id="dateTimeCreate"
                                label={messages['FSM_SETTINGS_TIME_CARD_date']}
                                value={TimeCardMData.dateTime}
                                onApply={(value) => {
                                    if (value > new Date()) {
                                        setError(messages['FSM_SETTINGS_TIME_CARD_error_date_edit'])
                                    } else {
                                        setTimeCardMData({ ...TimeCardMData, dateTime: value })

                                    }
                                }}
                                type='datetime'
                                style={{ paddingTop: 0 }}
                                maxDate={new Date()}
                                direction="row"
                                required
                            />
                        </Grid>


                    </Grid>
                </div>
            </ModalBody>
            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    className="btn-blue"
                    onClick={onSubmit}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default TimeCardMesssageEdit;